import React, { useEffect, useState } from 'react'
import { Select } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { equals, map, isNil } from 'ramda'
import { useTranslation } from 'react-i18next'
import { getOptions, getUserValue } from '../utils'
import { fetchEmployment } from '../../api'
import { usePrevious } from '../../utils/hooks'

const ExternalSelectEmployment = ({ label, name, additionalInfo, showLabelAsPlaceholder }) => {
  const { t, i18n } = useTranslation()
  const [value, setValue] = useState('')
  const [employmentList, setEmploymentList] = useState([])
  const [fullEmploymentList, setFullEmploymentList] = useState([])
  const [isValid, setIsValid] = useState(null)
  const [{ user, form: { accId } }, dispatch] = useStore()
  const userValue = getUserValue(accId, user, name)

  const prevLanguage = usePrevious(i18n.language)

  useEffect(() => {
    fetchEmployment().then(
      /**
       * @param {OptionsInput[]} employment
       */
      (employment) => {
        setFullEmploymentList(employment)
        setEmploymentList(getOptions(employment))
      })
  }, [i18n.language])

  useEffect(() => {
    if (!isNil(userValue) && prevLanguage === i18n.language) {
      const isEmploymentExist = fullEmploymentList.findIndex(({ id }) => id === userValue)
      const stringValue = isEmploymentExist !== -1 ? userValue.toString() : ''
      setValue(stringValue)
      const isValid = stringValue.length > 0
      setIsValid(isValid)
      dispatch({ type: 'setExtFieldValue', name, value: +stringValue })
      dispatch({ type: 'setValidationFld', name, value: isValid })
      setDetailsRequired(stringValue)
    }
  }, [userValue, fullEmploymentList, name, i18n.language])

  /**
   * @param {string} value
   */
  const getSelectValue = (value) => (equals(value, t('generatedField.choose')) ? '' : value)

  /**
   * @param {string} value
   */
  const setDetailsRequired = (value) => {
    const employmentItem = fullEmploymentList.find(item => item.id === +value)
    if (employmentItem) {
      dispatch({
        type: 'setExtFieldValue',
        value: employmentItem.detailsRequired,
        name: 'employmentDetailsIsShown'
      })
      dispatch({ type: 'setExtFieldValue', value: employmentItem.employed, name: 'isEmployed' })
    } else {
      dispatch({
        type: 'setExtFieldValue',
        value: false,
        name: 'employmentDetailsIsShown'
      })
      dispatch({ type: 'setExtFieldValue', value: null, name: 'isEmployed' })
    }
  }

  const onChange = ({ target: { value, name } }) => {
    const selectedValue = getSelectValue(value)
    setValue(selectedValue)
    setIsValid(!!selectedValue.length)

    dispatch({
      type: 'setExtFieldValue',
      name,
      value: +selectedValue
    })

    dispatch({
      type: 'setValidationFld',
      name,
      value: selectedValue.length > 0
    })
    setDetailsRequired(value)
  }

  return (
    <Select
      value={value || ''}
      label={t(label)}
      placeholder={t('generatedField.choose')}
      options={employmentList}
      onChange={onChange}
      name={name}
      key={name}
      error=''
      valid={isValid}
      info={additionalInfo ? t(`generatedField.${name}AdditionalInfo`) : ''}
      showLabelAsPlaceholder={showLabelAsPlaceholder}
    />
  )
}

const getExternalEmploymentFields = map(currencyField => {
  const { i18n, name, required, order } = currencyField
  return (
    <ExternalSelectEmployment
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      required={required}
      key={name}
      order={order}
    />
  )
})

export { ExternalSelectEmployment, getExternalEmploymentFields }
